var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7657 0.359252C15.4533 0.0468143 14.9468 0.0468143 14.6343 0.359252L5.04983 9.94385L1.3657 6.25972C1.0533 5.94728 0.546797 5.94731 0.234328 6.25972C-0.0781094 6.57213 -0.0781094 7.07863 0.234328 7.39106L4.48414 11.6408C4.79645 11.9532 5.30333 11.953 5.61552 11.6408L15.7657 1.49063C16.0781 1.17822 16.0781 0.671689 15.7657 0.359252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.62d02db3f2e9145f41c05c96739d848c.svg";
export { ForwardRef as ReactComponent };